import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CustomerEmojiBackground from 'components/icons/CustomerEmojiBackground';

const getRandomEmoji = () => {
  const emojiArray = [
    '😁',
    '😃',
    '😄',
    '😊',
    '😋',
    '😎',
    '😍',
    '🤗',
    '🤩',
    '😏',
    '😬',
    '🥳',
    '🤭',
  ];

  const randomIndex = Math.floor(Math.random() * emojiArray.length);

  return emojiArray[randomIndex];
};

const RandomCustomerEmoji = ({ customerName = '' }) => {
  const backgroundId = `RandomCustomerEmoji__background-${customerName
    .replace(/[. ]/gi, '')
    .toLowerCase()}`;

  const [emojiToRender, setEmojiToRender] = useState('');

  useEffect(() => {
    setEmojiToRender(getRandomEmoji());
  }, [setEmojiToRender, customerName]);

  return (
    <span className="block h-[42px] relative w-[42px] md:h-[60px] md:w-[60px]">
      <CustomerEmojiBackground id={backgroundId} className="h-full w-full" />
      <span className="items-center bottom-0 flex text-[1.3rem] justify-center left-0 absolute right-0 top-0 md:text-[1.8rem]">
        {emojiToRender}
      </span>
    </span>
  );
};

RandomCustomerEmoji.propTypes = {
  customerName: PropTypes.string,
};

export default RandomCustomerEmoji;
